export default {
  name: 'Isle Of Man',
  phonePattern: '',
  postalCodePattern: 'AA11##A',
  singlePostalCode: '',
  postalCodeRegex: '^(IM)([\\d]){2,3}([A-Za-z]){2}$',
  language: '',
  dobFormat: 'DD MM YY'
}



// WEBPACK FOOTER //
// ./src/locales/countries/IM.js